import { logger } from './logger';

type Subscription = {
  id: string;
  callback: (event: any) => void;
};

type Subscriptions = {
  [eventType: string]: Subscription[];
};

export class EventBus {
  private static subscriptions: Subscriptions = {};

  static subscribe<T>(eventType: string, callback: (event: T) => void): string {
    const id = Math.random().toString(36).substr(2, 9);
    
    if (!this.subscriptions[eventType]) {
      this.subscriptions[eventType] = [];
    }
    
    this.subscriptions[eventType].push({ id, callback });
    return id;
  }

  static unsubscribe(eventType: string, subscriptionId: string): void {
    if (!this.subscriptions[eventType]) return;
    
    this.subscriptions[eventType] = this.subscriptions[eventType].filter(
      (sub) => sub.id !== subscriptionId
    );
  }

  static publish<T>(event: { type: string; payload: T }): void {
    if (!this.subscriptions[event.type]) return;
    
    this.subscriptions[event.type].forEach((subscription) => {
      try {
        subscription.callback(event.payload);
      } catch (error) {
        logger.error(`Error in event subscription for ${event.type}:`, error);
      }
    });
  }

  static clearSubscriptions(): void {
    this.subscriptions = {};
  }
}